/* eslint-disable @typescript-eslint/no-explicit-any */
import { Container } from '@adobe/aem-react-editable-components';
import { respGridUtil } from '@marriott/mi-headless-utils';
import clsx from 'clsx';

export const DynamicWrapperConfig = {
  emptyLabel: 'dynamicWrapper',
  isEmpty: false,
  resourceType: `mi-aem-common-spa/components/common/dynamicwrapper`,
};

export const DynamicWrapperEditable = (props: any) => {
  return (
    <Container
      isInEditor
      {...props}
      isPage={false}
      model={respGridUtil(props?.model?.cqItems?.root?.[':items']?.responsivegrid)}
    />
  );
};

export const DynamicWrapper = (props: any) => {
  return props?.model?.styleclass ? (
    <div
      className={clsx(
        props?.model?.styleclass,
        props?.model?.styleclass.includes('fullbleed') ? 'm-container-fullbleed' : ''
      )}
    >
      <DynamicWrapperEditable {...props} />
    </div>
  ) : (
    <DynamicWrapperEditable {...props} />
  );
};
